import { WORKOUT_EXERCISE_KEY } from '../../../model'
import { EXERCISE_KEY } from '../../../../exercise'
import { updateCurrentIdExerciseAction } from '../../../../exercise/redux/actions/update-current'
import getByIdExerciseSelector from '../../../../exercise/redux/selectors/get-by-id'
import createPointerReduxUtil from '../../../../redux/utils/create-pointer'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import updateWorkoutExerciseAction from '../update'
import WORKOUT_EXERCISES_ACTION from '../../constants/action'
import getByIdWorkoutExerciseSelector from '../../selectors/get-by-id'
import getCurrentWorkoutExerciseSelect from '../../selectors/get-current'
import updateLocalHasAssociationChangeWorkoutAction
  from '../../../../workout/redux/actions/update-local-has-association-change'

function updateExerciseWorkoutExerciseAction (params) {
  return (dispatch, getState) => {
    let {
      exerciseId,
      id
    } = params
    const workoutExercise = (
      getByIdWorkoutExerciseSelector(id)(getState()) ||
      getCurrentWorkoutExerciseSelect(getState())
    )
    const exercise = getByIdExerciseSelector(exerciseId)(getState())
    if (!workoutExercise) {
      return
    }
    exerciseId = getIdReduxUtil(exercise)
    dispatch(updateWorkoutExerciseAction({
      type: WORKOUT_EXERCISES_ACTION.UPDATE_EXERCISE,
      payload: {
        workoutExercise,
        keys: [
          WORKOUT_EXERCISE_KEY.EXERCISE,
          WORKOUT_EXERCISE_KEY.EXERCISE_ID
        ],
        values: [
          createPointerReduxUtil(exercise, [EXERCISE_KEY.NAME]),
          exerciseId
        ]
      }
    }))
    dispatch(updateLocalHasAssociationChangeWorkoutAction())
    dispatch(updateCurrentIdExerciseAction(exerciseId))
  }
}

export default updateExerciseWorkoutExerciseAction
